enum DeviceHandoffOption {
  Email = 'email',
  Sms = 'sms',
  Qr = 'qr',
}

export default DeviceHandoffOption;
